import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import FIODTO from '../../../../dto/FIODTO';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import { addressTransform, nameTransform } from '../../../../utils/utils';
import { required } from '../../../../utils/validation';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../configs';

export default function FIOForm(props) {
  const {
    prefix = '',
    labelPrefix = '',
    disabled,
    control,
    formMeta,
    procedure,
    applicantType,
  } = props;
  const dto = new FIODTO();
  const attributes = dto.getAttributesByName();

  const resultAttributes = labelPrefix
    ? Object.fromEntries(
      Object.entries(attributes).map(([key, attribute]) => [
        key,
        {
          ...attribute,
          validators: attribute.validators?.filter(validator => validator !== required) || [],
        },
      ]),
    )
    : attributes;

  return (
    <Row className="row-cols-3">
      <FieldDTOWithCol
        control={control}
        formMeta={formMeta}
        type="text"
        component={TextInputWithLabel}
        dtoObject={resultAttributes.last_name}
        variant="material"
        namePrefix={prefix}
        // disabled={disabled
        //     || (
        //       (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3 && applicantType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR)
        //     || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5 && [USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType))
        //     || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8 && [USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType))
        //     )}
        labelPrefix={labelPrefix}
        transform={nameTransform}
      />
      <FieldDTOWithCol
        control={control}
        formMeta={formMeta}
        type="text"
        component={TextInputWithLabel}
        dtoObject={resultAttributes.first_name}
        variant="material"
        namePrefix={prefix}
        // disabled={disabled
        //     || (
        //       (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3 && applicantType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR)
        //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5 && [USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType))
        //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8 && [USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType))
        //     )}
        labelPrefix={labelPrefix}
        transform={nameTransform}
      />
      <FieldDTOWithCol
        control={control}
        formMeta={formMeta}
        type="text"
        component={TextInputWithLabel}
        dtoObject={resultAttributes.middle_name}
        variant="material"
        namePrefix={prefix}
        // disabled={disabled
        //     || (
        //       (procedure === PROCEDURE_TYPE.PROCEDURE_1228_3 && applicantType === USER_TYPE.INDIVIDUAL_ENTREPRENEUR)
        //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_5 && [USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType))
        //         || (procedure === PROCEDURE_TYPE.PROCEDURE_1227_8 && [USER_TYPE.PRIVATE_PERSON, USER_TYPE.INDIVIDUAL_ENTREPRENEUR].includes(applicantType))
        //     )}
        labelPrefix={labelPrefix}
        transform={nameTransform}
      />
    </Row>
  );
}
